import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useQualityChecklist from "./useQualityChecklist";
import { Search } from "lucide-react";

const QualityChecklist = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    isChecklistLoading,
    checklist,
    isView,
  } = useQualityChecklist();

  return (
    <div>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Checklist for Quality" />
          {isMobile && !isView && (
            <Button onClick={onAdd} className="px-2">
              + Add Checklist
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && !isView && (
            <Button onClick={onAdd}>+ Add Checklist</Button>
          )}
        </div>
      </div>

      {/* Responsive Table */}
      {isChecklistLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(checklist?.data || [])?.sort(
            (a: any, b: any) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      )}
    </div>
  );
};

export default QualityChecklist;
